module.exports = __webpack_public_path__ + "img/map.34c9bc6d.png";